export enum PersonalizationType {
  MY_CONCERN_TAGS = 'MY_CONCERN_TAGS',
  MY_CONCERN_BODY_PART_TAGS = 'MY_CONCERN_BODY_PART_TAGS',
  FAVORITE_TREATMENTS = 'FAVORITE_TREATMENTS',
  MY_CUSTOMER_JOURNEY = 'MY_CUSTOMER_JOURNEY',
}
export interface Personalization {
  id: number
  memberId: number
  personalizationType: PersonalizationType
  customerJourney: string | null
  concernTagIdList: number[]
  concernBodyPartTagIdList: number[]
  treatmentIdList: number[]
}
